/* app/ui/header/menu */

define(
	'app/ui/header/menu',[
		'jquery',
		'util/mediaqueries',
		'app/ui/header/nav.small',
		'app/ui/header/nav.large',
		'util/keybinding',
		'velocity',
		'pubsub',
		'throttledebounce'
	],
	function ($, MediaQueries, NavSmall, NavLarge, Keybinding, Velocity) {

		var Module;

		var sharedSelectors = {
			nav: '.js-nav',
			navItem: '.js-nav__parent',
			navLink: '.js-nav__parent-link',
			navChildren: '.js-nav__children',
			noTouch: '.no-touchevents',
		};

		var classes;

		var $menu;
		var $menuToggle;
		var $phoneToggle;
		var $headNavDesktop;

		return {
			init: function (classList) {
				Module = this;
				classes = classList;

				Module._initElements();
				Module._initMediaQueries();
				Module._initSubscriptions();
				Module._initEvents();
			},

			_initElements: function () {
				$menu = $('.js-menu');
				$menuToggle = $('.js-menu-toggle');
				$headNavDesktop = $('.js-head-nav');
				$phoneToggle = $('.js-header__phone-toggle-lg');
			},

			_initSubscriptions: function () {
				$.subscribe('/header/searchToggle', Module._closeMenu);
				//$.subscribe('/header/navReset', Module._closeMenu);
			},

			_initEvents: function () {
				$menuToggle.on('click', Module._toggleMenu);
				Keybinding.bindKey('ESC', Module._closeMenu);
				$phoneToggle.on('click', function () {
					$(this).toggleClass('is-expanded');
				});
				$headNavDesktop.on('click', Module._openNavDesktop);
			},

			_initMediaQueries: function () {

				MediaQueries.register([
					{
						// Bind Small Nav
						queries: MediaQueries.queries['megamenu--small'],
						shouldDegrade: false,
						match: function () {
							NavSmall.init($menu, sharedSelectors, classes);
						},
						unmatch: function () {
							NavSmall.unbind($menu, sharedSelectors, classes);
						}
					}, {
						// Bind Large Nav
						queries: MediaQueries.queries['megamenu--large'],
						shouldDegrade: true,
						match: function () {
							NavLarge.init($menu, sharedSelectors, classes);
							//nav scroll top overlap fix
							$menu.scroll($.throttle(250, function () {
								if ($menu.scrollTop() > 50) {
									$menu.addClass('header-scrolling-top');
								}
								else {
									$menu.removeClass('header-scrolling-top');
								}
							}));
						},
						unmatch: function () {
							NavLarge.unbind($menu, sharedSelectors, classes);
						}
					}
				]);
			},

			// publish nav toggle event
			// show menu if collapsed, add padding and scrollable class when animation complete
			// hide menu if showing, remove padding and scrollable class before animation begins
			// toggle class on menu button
			_toggleMenu: function (event) {
				event.preventDefault();
				$.publish('/header/navToggle');
				$menuToggle.toggleClass(classes.expanded);

				if ($menu.hasClass(classes.collapsed)) {
					$menu.velocity(
						{
							height: '100%',
							paddingTop: 46
						},
						{
							duration: 250,
							begin: Module._menuOpening,
							complete: Module._menuOpened
						}
					);
				} else {
					$menu.velocity(
						{
							height: '0%',
							paddingTop: 0
						},
						{
							duration: 250,
							begin: Module._menuClosing,
							complete: Module._menuClosed
						}
					);
				}
			},

			_openNavDesktop: function (event) {
				event.preventDefault();
				var $target = $(event.target);
				if (!$('body').hasClass(classes.dropdownOpen)) {
					$menuToggle.eq(0).trigger('click');
					//Module._toggleMenu(event);
				}
				$('.js-head-nav').removeClass('is-selected');
				$target.addClass('is-selected');
				var index = $target.data('nav-index');
				$('.js-nav__children').removeClass('show');
				$('.js-nav__children').eq(index).addClass('show');
			},

			_menuOpening: function () {
				$.publish('/header/toggleDropdown', { transform: 'addClass' });
			},

			_menuOpened: function () {
				$menu.addClass(classes.scrolling);
				$menu.removeClass(classes.collapsed);
			},

			_menuClosing: function () {
				$menu.removeClass(classes.scrolling);
				$menu.addClass(classes.collapsed);
			},

			_menuClosed: function () {
				$.publish('/header/toggleDropdown', { transform: 'removeClass' });
				$.publish('/window/scroll'); // Cause sticky nav to re-evaluate
			},

			// close primary nav menu if open
			_closeMenu: function () {
				if ($menuToggle.eq(0).hasClass(classes.expanded)) {
					$menuToggle.eq(0).trigger('click');
				}
			}
		};
	}
);
